import type { TicketingVolumeTrendsPayload } from '../components/types';

export const TICKETING_VOLUME_TRENDS_MOCK: TicketingVolumeTrendsPayload = {
	weeklyTicketVolume: {
		title: 'Weekly Ticket Volume',
		series: [
			{ label: 'W15', value: 184 },
			{ label: 'W16', value: 193 },
			{ label: 'W17', value: 201 },
			{ label: 'W18', value: 214 },
			{ label: 'W19', value: 223 },
			{ label: 'W20', value: 209 },
			{ label: 'W21', value: 201 },
			{ label: 'W22', value: 194 },
			{ label: 'W23', value: 186 },
			{ label: 'W24', value: 177 },
			{ label: 'W25', value: 183 },
			{ label: 'LCW', value: 176 },
		],
	},
	ticketsByPriority: {
		selectedView: 'total',
		total: {
			totalTickets: 1284,
			segments: [
				{ name: 'Critical', value: 38, percentage: 3.0, color: '#D32F2F' },
				{ name: 'High', value: 276, percentage: 21.5, color: '#F57C00' },
				{ name: 'Medium', value: 714, percentage: 55.6, color: '#1976D2' },
				{ name: 'Low', value: 256, percentage: 19.9, color: '#388E3C' },
			],
		},
		open: {
			totalTickets: 202,
			segments: [
				{ name: 'Critical', value: 14, percentage: 6.9, color: '#D32F2F' },
				{ name: 'High', value: 58, percentage: 28.7, color: '#F57C00' },
				{ name: 'Medium', value: 92, percentage: 45.5, color: '#1976D2' },
				{ name: 'Low', value: 38, percentage: 18.9, color: '#388E3C' },
			],
		},
	},
	resolutionTimeByPriority: [
		{ name: 'Critical', value: 6.8, unit: 'hours', color: '#C12C01' },
		{ name: 'High', value: 14.2, unit: 'hours', color: '#FF8C09' },
		{ name: 'Medium', value: 27.5, unit: 'hours', color: '#005CBC' },
		{ name: 'Low', value: 41.9, unit: 'hours', color: '#33ABDA' },
	],
	submissionHeatMap: {
		days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
		hours: [
			'00', '01', '02', '03', '04', '05',
			'06', '07', '08', '09', '10', '11',
			'12', '13', '14', '15', '16', '17',
			'18', '19', '20', '21', '22', '23',
		],
		matrix: [
			[0, 0, 0, 0, 0, 0, 0, 1, 3, 6, 8, 5, 4, 6, 8, 7, 5, 4, 3, 2, 1, 0, 0, 0],
			[0, 0, 0, 0, 0, 0, 1, 3, 8, 14, 18, 16, 12, 14, 17, 15, 13, 10, 8, 5, 2, 1, 0, 0],
			[0, 0, 0, 0, 0, 1, 2, 5, 11, 18, 22, 20, 18, 21, 24, 22, 18, 15, 12, 8, 4, 2, 1, 0],
			[0, 0, 0, 0, 0, 1, 3, 6, 12, 20, 25, 23, 20, 24, 27, 25, 20, 18, 13, 9, 5, 3, 1, 0],
			[0, 0, 0, 0, 0, 1, 2, 5, 10, 18, 24, 22, 20, 22, 24, 23, 20, 16, 12, 8, 5, 2, 1, 0],
			[0, 0, 0, 0, 0, 0, 1, 3, 8, 14, 17, 16, 14, 15, 16, 15, 12, 9, 6, 4, 2, 1, 0, 0],
			[0, 0, 0, 0, 0, 0, 0, 1, 2, 4, 6, 5, 4, 5, 6, 6, 5, 4, 3, 2, 1, 0, 0, 0],
		],
	},
	resolutionHeatMap: {
		days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
		hours: [
			'00', '01', '02', '03', '04', '05',
			'06', '07', '08', '09', '10', '11',
			'12', '13', '14', '15', '16', '17',
			'18', '19', '20', '21', '22', '23',
		],
		matrix: [
			[0, 0, 0, 0, 0, 0, 0, 0, 1, 2, 3, 2, 2, 3, 4, 4, 3, 2, 1, 1, 0, 0, 0, 0],
			[0, 0, 0, 0, 0, 0, 0, 2, 5, 10, 14, 13, 10, 12, 15, 13, 11, 9, 7, 5, 2, 1, 0, 0],
			[0, 0, 0, 0, 0, 0, 1, 3, 7, 14, 18, 17, 14, 17, 20, 18, 15, 12, 9, 6, 3, 2, 1, 0],
			[0, 0, 0, 0, 0, 0, 1, 4, 8, 16, 22, 20, 17, 20, 24, 22, 18, 14, 11, 8, 4, 2, 1, 0],
			[0, 0, 0, 0, 0, 0, 1, 3, 7, 15, 20, 18, 16, 18, 20, 19, 16, 13, 10, 6, 3, 2, 1, 0],
			[0, 0, 0, 0, 0, 0, 0, 2, 5, 10, 13, 12, 10, 11, 13, 12, 10, 8, 6, 4, 2, 1, 0, 0],
			[0, 0, 0, 0, 0, 0, 0, 1, 2, 4, 5, 5, 4, 4, 5, 5, 4, 3, 2, 1, 1, 0, 0, 0],
		],
	},
};

